import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import logo from '../logo-big-transparent.png'; // Adjust the path as necessary

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    // Smooth scrolling logic
    const handleSmoothScroll = (e) => {
      e.preventDefault();
      const targetId = e.currentTarget.getAttribute('href');
      if (targetId === '#') return;

      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 80,
          behavior: 'smooth'
        });

        // Close mobile menu if open after clicking a link
        if (isMobileMenuOpen) {
          setIsMobileMenuOpen(false);
        }
      }
    };

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', handleSmoothScroll);
    });

    return () => {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.removeEventListener('click', handleSmoothScroll);
      });
    };
  }, [isMobileMenuOpen]);

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    // Adjust this offset value (e.g., 90, 100, 120) based on your header's height
    // and how much background space you want above the section.
    const yOffset = -75; // Negative value to scroll UP by 90 pixels

    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });

    // Close mobile menu if open after clicking a link (if applicable for HashLink)
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
    }
  };


  return (
    <header className="fixed w-full z-50">
      <nav className="glass-card px-6 py-4">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center"> {/* Use Link for navigation to home */}
            {/* Adjust h-X (e.g., h-14, h-16) to make the logo bigger. */}
            {/* w-auto will ensure it maintains its aspect ratio. */}
            <img src={logo} alt="DEVCORE Logo" className="h-8 w-auto object-contain" />
            {/* If you want the "DEVCORE" text next to the logo, uncomment this line: */}
            {/* <span className="text-2xl font-bold gradient-text ml-2">DEVCORE</span> */}
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="nav-link text-white hover:text-devcore.primary transition">Home</Link>
            <Link to="/scripts" className="nav-link text-white hover:text-devcore.primary transition">Scripts</Link>
            <Link to="/docs" className="nav-link text-white hover:text-devcore.primary transition">Docs</Link>
            <HashLink smooth to="/#team" scroll={scrollWithOffset} className="nav-link text-white hover:text-devcore.primary transition">Team</HashLink>
            {/* <button className="px-4 py-2 bg-[#316dae] rounded-md text-white hover:bg-blue-600 transition">
              Login
            </button>
            <button className="px-4 py-2 glass-card rounded-md text-white hover:bg-white hover:bg-opacity-10 transition">
              Register
            </button> */}
            <a href="https://store.devcore.cz" target="_blank" rel="noopener noreferrer" className="px-4 py-2 bg-[#316dae] rounded-md text-white hover:bg-blue-600 transition flex items-center space-x-2">
              <span>Visit Store</span>
              <i className="fas fa-external-link-alt text-sm"></i>
            </a>
            <button className="px-4 py-2 bg-gray-700 rounded-md text-white hover:bg-gray-600 transition flex items-center space-x-2">
                  <span>Go to Panel</span>
                  <i className="fas fa-th-large"></i>
                </button>
          </div>

          {/* Mobile menu button */}
          <button id="mobile-menu-button" className="md:hidden text-white focus:outline-none" onClick={toggleMobileMenu}>
            <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        <div id="mobile-menu" className={`md:hidden mt-4 pb-4 ${isMobileMenuOpen ? 'block' : 'hidden'}`}>
          <Link to="/" className="block py-2 text-white hover:text-devcore.primary transition" onClick={toggleMobileMenu}>Home</Link>
          <Link to="/scripts" className="block py-2 text-white hover:text-devcore.primary transition" onClick={toggleMobileMenu}>Scripts</Link>
          <Link to="/docs" className="block py-2 text-white hover:text-devcore.primary transition" onClick={toggleMobileMenu}>Docs</Link>
          <HashLink smooth to="/#team" scroll={scrollWithOffset} className="block py-2 text-white hover:text-devcore.primary transition">Team</HashLink>
          <a href="https://store.devcore.cz" target="_blank" rel="noopener noreferrer" className="block mt-2 px-4 py-2 bg-devcore.primary rounded-md text-white hover:bg-blue-600 transition flex items-center space-x-2">
            <span>Visit Store</span>
            <i className="fas fa-external-link-alt text-sm"></i>
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Header;